import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {Colour} from '@/app/core/models/p-place/colour';

@Injectable({
	providedIn: 'root'
})
export class ColourService {

	private readonly http = inject(HttpClient);

	private readonly SERVICE_URI = `${environment.backendUrl}/colours`;

	getColours(): Observable<Colour[]> {
		return this.http.get<Colour[]>(this.SERVICE_URI);
	}
}
